import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { isFeatureEnabled } from 'owa-feature-flags';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export default function getPersonaControlKey(
    emailAddress: string,
    personaId: string,
    size: PersonaSize,
    mailboxType: string,
    name?: string
): string {
    let personaControlKey = '';
    const isIAPIEnabled = isFeatureEnabled('rp-imageApiConsumer') && isConsumer();

    if (emailAddress) {
        personaControlKey += emailAddress.toLowerCase();
    } else if (personaId) {
        personaControlKey += personaId;
    } else if (name) {
        personaControlKey += name.toLowerCase();
    }

    // Mailbox type is only used with IAPI
    if (mailboxType && isIAPIEnabled) {
        personaControlKey += mailboxType;
    }

    // IAPI is currently only fetching one size of persona image
    // Omit it from the key if IAPI is enabled
    if (size && !isIAPIEnabled) {
        personaControlKey += size;
    }

    return personaControlKey;
}
